import { client } from "./graphql/client"
import { formatApolloError } from "./graphql/error";
import { getKycVerificationDetailsQuery } from "./graphql/kyc/queries";

export const kycVerificationDataProvider = {

    getOne: async(resource, params) => {
        const { customerId } = params

        try {
            const result = await client.query({
                query: getKycVerificationDetailsQuery,
                variables: { customerId: customerId },
                fetchPolicy: 'network-only' // Always fetch fresh data
            })

            const response = result.data
    
            return {
                data: {
                    id: customerId,
                    result: response
                }
            }
        } catch (e) {
            return Promise.resolve({
                data: {
                    id: -1,
                    error: formatApolloError(e)
                }
            });
        }
    }
}

